const url = process.env.VUE_APP_URL_API
const cdiac =  'https://cdiac.manizales.unal.edu.co/'
export default {
        login: url+"api/querySystem/login",
        logout: url+"api/querySystem/logout",
        createUser: url+"api/querySystem/user/create",
        activeUser: url+"api/querySystem/user/activate",
        inactiveUser: url+"api/querySystem/user/inactivate",
        updateUserPassword: url+"api/querySystem/user/updatePassword",
        deleteUser: url+"api/querySystem/user/delete",
        getUsers: url+"api/querySystem/user/userList",
        total_quantity_data: url+"api/querySystem/totalData",
        get_stations_by_typology: url+"api/querySystem/getStationsByTypology",
        get_dateRange_by_station_and_typology: url+"api/querySystem/getDateRangeByStationAndTypology",
        get_users: url+"api/querySystem/user/userList",
        get_variables_by_station: url+"api/querySystem/getVariablesByStation",
        get_station_name_by_id: url+"api/querySystem/getStationNameById",
        get_airQuality_data_by_station: url+"api/querySystem/getAirQualityDataByStation",
        get_hydrometeorological_data_by_station: url+"api/querySystem/getHydrometeorologicalDataByStation",
        get_groundWater_data_by_station: url+"api/querySystem/getGroundWaterDataByStation",
        urlCdiac: cdiac,
        request_password_reset: url+"api/querySystem/requestPasswordReset",
        password_reset: url+"api/querySystem/passwordReset",
        get_role_list: url+"api/querySystem/getRoleList"
};